export enum LangEnum {
    AR = 'ar',
    CA = 'ca',
    DE = 'de',
    EN = 'en',
    ES = 'es',
    FR = 'fr',
    HR = 'hr',
    ID = 'id',
    IT = 'it',
    JA = 'ja',
    KO = 'ko',
    LV = 'lv',
    OC = 'oc',
    PT = 'pt',
    RO = 'ro',
    RU = 'ru',
    SL = 'sl',
    SV = 'sv',
    TH = 'th',
    TR = 'tr',
    ZH_SIMPLIFY = 'zh-Hans',
    ZH_TRADITIONAL = 'zh-Hant',
}
